var _path, _path2, _path3, _path4, _circle, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPays = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 22.1667H24.5001Z",
    fill: "url(#paint0_linear_640_6519)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 22.1667H24.5001",
    stroke: "url(#paint1_linear_640_6519)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14H24.5001",
    stroke: "url(#paint2_linear_640_6519)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 5.83334H24.5001",
    stroke: "url(#paint3_linear_640_6519)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.83333,
    cy: 5.83333,
    r: 1.75,
    fill: "url(#paint4_linear_640_6519)",
    stroke: "url(#paint5_linear_640_6519)",
    strokeWidth: 1.16667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8877 12.2497C6.89705 12.2497 7.6922 13.046 7.69238 13.9997C7.69238 14.9535 6.89716 15.7497 5.8877 15.7497C4.87835 15.7495 4.08301 14.9534 4.08301 13.9997C4.08319 13.0461 4.87847 12.2498 5.8877 12.2497Z",
    fill: "url(#paint6_linear_640_6519)",
    stroke: "url(#paint7_linear_640_6519)",
    strokeWidth: 1.16667
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8877 20.4163C6.89705 20.4163 7.6922 21.2126 7.69238 22.1663C7.69238 23.1202 6.89716 23.9163 5.8877 23.9163C4.87835 23.9162 4.08301 23.1201 4.08301 22.1663C4.08319 21.2127 4.87847 20.4165 5.8877 20.4163Z",
    fill: "url(#paint8_linear_640_6519)",
    stroke: "url(#paint9_linear_640_6519)",
    strokeWidth: 1.16667
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_6519",
    x1: 11.6667,
    y1: 22.5917,
    x2: 24.5001,
    y2: 22.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_6519",
    x1: 11.6667,
    y1: 22.5917,
    x2: 24.5001,
    y2: 22.5917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_6519",
    x1: 11.6667,
    y1: 14.425,
    x2: 24.5001,
    y2: 14.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_640_6519",
    x1: 11.6667,
    y1: 6.25834,
    x2: 24.5001,
    y2: 6.25834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_640_6519",
    x1: 3.5,
    y1: 5.48333,
    x2: 8.16667,
    y2: 5.48333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_640_6519",
    x1: 3.5,
    y1: 5.48333,
    x2: 8.16667,
    y2: 5.48333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_640_6519",
    x1: 3.5,
    y1: 13.65,
    x2: 8.27592,
    y2: 13.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_640_6519",
    x1: 3.5,
    y1: 13.65,
    x2: 8.27592,
    y2: 13.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_640_6519",
    x1: 3.5,
    y1: 21.8167,
    x2: 8.27592,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_640_6519",
    x1: 3.5,
    y1: 21.8167,
    x2: 8.27592,
    y2: 21.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPays, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pays.fa1a170a.svg";
export { ForwardRef as ReactComponent };